/**
 * Finds the cell reference at current caret position
 * @param {number} position - Caret position
 * @param {Array} cells - Available formula cells
 * @returns {Object|null} Found cell or null
 */
export const findCurrentCell = (position, cells) => {
    if (!cells || !Array.isArray(cells)) return null;
    return cells.find(cell => cell.from <= position && position <= cell.to) || null;
  };
  
  /**
   * Calculates new cell positions based on key press
   * @param {Object} currentRange - Current cell range {sri, sci, eri, eci}
   * @param {number} keyCode - Pressed arrow key code
   * @param {boolean} isShiftPressed - Whether shift is held
   * @returns {Object} New positions {startRow, startCol, endRow, endCol}
   */
  export const calculateNewRange = ({ sri, sci, eri, eci }, keyCode, isShiftPressed) => {
    let startRow = sri, startCol = sci, endRow = eri, endCol = eci;
  
    const movement = {
      37: () => isShiftPressed ? endCol-- : (startCol--, endCol--), // Left
      38: () => isShiftPressed ? endRow-- : (startRow--, endRow--), // Up
      39: () => isShiftPressed ? endCol++ : (startCol++, endCol++), // Right
      40: () => isShiftPressed ? endRow++ : (startRow++, endRow++)  // Down
    };
  
    movement[keyCode]?.();
  
    return {
      startRow: Math.max(0, startRow),
      startCol: Math.max(0, startCol),
      endRow: Math.max(0, endRow),
      endCol: Math.max(0, endCol)
    };
  };
  
  /**
   * Updates formula with new cell range
   * @param {Object} context - Formula component instance
   * @param {Object} range - New cell range
   * @param {Function} generalSelectCell - Selection handler
   */
  export const updateFormulaSelection = (context, range, generalSelectCell) => {
    generalSelectCell.call(context, range.sri, range.sci, range.eri, range.eci);
    context.cellSelectStartRowCol = [range.sri, range.sci];
    context.cellSelectEndRowCol = [range.eri, range.eci];
  };